import type { GetImpactRatingsByImpactIdResponseRow } from '@risksmart-app/drizzle/src/types';
import type { GetImpactRatingsByImpactIdQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetImpactRatingsByImpactIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

type UseGetImpactRatingsByImpactIdArgs = {
  impactId: string;
};

export const useGetImpactRatingsByImpactId = createQueryHook<
  UseGetImpactRatingsByImpactIdArgs,
  GetImpactRatingsByImpactIdResponseRow[],
  GetImpactRatingsByImpactIdQuery
>({
  trpcQueryOptions: (trpc, { impactId }) =>
    trpc.frontend.impactRating.impactRatingsByImpactId.queryOptions({
      impactId,
    }),
  mapTrpcDataToGraphQL: (data) => ({ impact_rating: data }),
  graphqlDocument: GetImpactRatingsByImpactIdDocument,
  graphqlVariables: ({ impactId }) => ({ impactId }),
});
